import * as React from "react";
import { Path, G, Rect, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const ESIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="ES" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#FFB400"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#C51918"
          fillRule="evenodd"
          d="M0 0v3h16V0H0ZM0 9v3h16V9H0Z"
          clipRule="evenodd"
        />
        <Path fill="#F1F9FF" d="M2.504 5.136h.56v2.912h-.56z" />
        <Path
          fill="#C88A02"
          d="M3.288 4.912H3.12v.224h-.672v-.224H2.28v-.28h1.008v.28Z"
        />
        <Path
          fill="#C88A02"
          fillRule="evenodd"
          d="M3.12 8.216h.168v.28H2.28v-.28h.168v-.224h.672v.224Z"
          clipRule="evenodd"
        />
        <Path
          fill="#AD1619"
          fillRule="evenodd"
          d="M2.784 4.688c.122 0 .134-.046.206-.114.056-.054.186-.12.186-.194 0-.17-.175-.308-.392-.308-.216 0-.392.138-.392.308 0 .083.09.138.157.194.072.058.124.114.235.114Z"
          clipRule="evenodd"
        />
        <Path
          fill="#005BBF"
          fillRule="evenodd"
          d="M2.28 8.496h1.008v.448s-.126-.056-.252-.056-.252.056-.252.056-.126-.056-.252-.056-.252.056-.252.056v-.448Z"
          clipRule="evenodd"
        />
        <Mask
          id="c"
          width={2}
          height={1}
          x={2}
          y={8}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M2.28 8.496h1.008v.448s-.126-.056-.252-.056-.252.056-.252.056-.126-.056-.252-.056-.252.056-.252.056v-.448Z"
            clipRule="evenodd"
          />
        </Mask>
        <G fill="#fff" mask="url(#c)">
          <Path d="m2.27 8.856-.021-.054c.09-.04.182-.06.273-.06.059 0 .09.008.142.031.046.02.07.027.12.027.05 0 .074-.006.12-.027a.297.297 0 0 1 .142-.031c.092 0 .183.02.274.06l-.022.054a.613.613 0 0 0-.252-.056.245.245 0 0 0-.12.027.296.296 0 0 1-.142.031.296.296 0 0 1-.142-.031.245.245 0 0 0-.12-.027.613.613 0 0 0-.251.056ZM2.27 8.688l-.021-.054c.09-.04.182-.06.273-.06.059 0 .09.008.142.031.046.02.07.027.12.027.05 0 .074-.006.12-.027a.297.297 0 0 1 .142-.031c.092 0 .183.02.274.06l-.022.054a.613.613 0 0 0-.252-.056.245.245 0 0 0-.12.027.297.297 0 0 1-.142.031.297.297 0 0 1-.142-.031.245.245 0 0 0-.12-.027.613.613 0 0 0-.251.056Z" />
        </G>
        <Path fill="#F1F9FF" d="M7.992 5.136h.56v2.912h-.56z" />
        <Path
          fill="#C88A02"
          d="M8.776 4.912h-.168v.224h-.672v-.224h-.168v-.28h1.008v.28Z"
        />
        <Path
          fill="#C88A02"
          fillRule="evenodd"
          d="M8.608 8.216h.168v.28H7.768v-.28h.168v-.224h.672v.224Z"
          clipRule="evenodd"
        />
        <Path
          fill="#AD1619"
          fillRule="evenodd"
          d="M8.272 4.688c.122 0 .134-.046.206-.114.056-.054.186-.12.186-.194 0-.17-.175-.308-.392-.308-.216 0-.392.138-.392.308 0 .083.09.138.157.194.072.058.124.114.235.114Z"
          clipRule="evenodd"
        />
        <Path
          fill="#005BBF"
          fillRule="evenodd"
          d="M7.768 8.496h1.008v.448s-.126-.056-.252-.056-.252.056-.252.056-.126-.056-.252-.056-.252.056-.252.056v-.448Z"
          clipRule="evenodd"
        />
        <Mask
          id="d"
          width={2}
          height={1}
          x={7}
          y={8}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M7.768 8.496h1.008v.448s-.126-.056-.252-.056-.252.056-.252.056-.126-.056-.252-.056-.252.056-.252.056v-.448Z"
            clipRule="evenodd"
          />
        </Mask>
        <G fill="#fff" mask="url(#d)">
          <Path d="m7.759 8.856-.022-.054c.09-.04.182-.06.273-.06.059 0 .09.008.142.031.046.02.07.027.12.027.05 0 .074-.006.12-.027a.297.297 0 0 1 .142-.031c.092 0 .183.02.274.06l-.022.054a.613.613 0 0 0-.252-.056.245.245 0 0 0-.12.027.296.296 0 0 1-.142.031.296.296 0 0 1-.142-.031.245.245 0 0 0-.12-.027.613.613 0 0 0-.251.056ZM7.759 8.688l-.022-.054c.09-.04.182-.06.273-.06.059 0 .09.008.142.031.046.02.07.027.12.027.05 0 .074-.006.12-.027a.297.297 0 0 1 .142-.031c.092 0 .183.02.274.06l-.022.054a.613.613 0 0 0-.252-.056.245.245 0 0 0-.12.027.297.297 0 0 1-.142.031.297.297 0 0 1-.142-.031.245.245 0 0 0-.12-.027.613.613 0 0 0-.251.056Z" />
        </G>
        <Path
          fill="#AD1619"
          d="M2.194 5.936c.375-.259 1.38-.282 1.82-.054l-.206.398c-.216-.111-.707-.133-1.052-.076.053.01.111.02.177.03.04.006.183.029.197.03a.729.729 0 0 1 .3.096c.142.097.164.27.063.399a.608.608 0 0 1-.184.144 3.054 3.054 0 0 1-.096.053l-.096.05a1.53 1.53 0 0 0-.173.104 1.236 1.236 0 0 1-.197.117l-.15.066-.007.003c.04.053.061.118.061.192 0 .118-.056.23-.157.352l-.344-.283-.033-.011-.018-.143c-.034-.264.08-.411.313-.517l.14-.064a.804.804 0 0 0 .128-.074c.038-.027.078-.053.126-.081-.288-.046-.445-.08-.564-.132-.286-.123-.323-.41-.048-.6Zm4.797-.054c.44-.227 1.444-.205 1.82.054.274.189.238.476-.049.6-.12.05-.276.085-.564.131.048.028.089.054.126.081.038.028.079.05.128.074.03.015.135.061.141.064.233.106.347.253.313.517l-.019.143-.033.01-.344.284c-.1-.122-.157-.234-.157-.352 0-.074.022-.14.06-.192l-.005-.003-.15-.066a1.245 1.245 0 0 1-.198-.117 1.532 1.532 0 0 0-.173-.103c-.02-.01-.088-.047-.096-.05a3.033 3.033 0 0 1-.096-.054.603.603 0 0 1-.183-.144.267.267 0 0 1 .062-.399.728.728 0 0 1 .3-.095l.197-.032.177-.029c-.345-.057-.836-.035-1.052.076l-.205-.398Z"
        />
        <Path
          fill="#F1F9FF"
          d="m2.962 6.2.165.034v.247c-.176.14-.623.377-.623.377V6.2h.458ZM8.157 6.2l-.165.034v.247c.176.14.623.377.623.377V6.2h-.458Z"
        />
        <Path
          fill="#AD1619"
          d="M5.565 3.053c.31-.03.616.025.918.158.315 0 .617.103.905.31v.082l-.565.567c-.113.313-.314.33-.471.382-.054.017-.789.037-.789.037v-.002c-1.113.129-1.272-.417-1.272-.417l-.565-.567v-.082c.007-.005.436-.31.905-.31.01-.004.474-.203.934-.158Z"
        />
        <Path
          fill="#C88A02"
          d="M6.435 3.75c.012.14.05.205.106.215.077.012.135.006.176-.016l.083-.044v.076a.48.48 0 0 0 .13-.015l.018.08.413-.387.04.04-.514.483c-.075.138-.113.229-.113.267 0 .058-.15.093-.444.128-.23.027-.5.043-.721.046v.003l-.03-.002-.027.002v-.003a7.21 7.21 0 0 1-.723-.046c-.293-.035-.443-.07-.443-.128a.135.135 0 0 0-.006-.032.413.413 0 0 1-.055-.128c-.015-.031-.03-.068-.051-.107l-.115-.107h-.002v-.002l-.397-.374.038-.04.373.35.01-.043a.48.48 0 0 0 .132.015v-.076l.082.044c.04.022.099.028.175.016.057-.01.094-.075.107-.214l.025-.282.084.27c.038.122.096.176.179.176.08 0 .114-.03.117-.105l.01-.21.096.188c.034.068.082.1.15.1.096 0 .161-.081.161-.208h.113c0 .127.066.207.163.207.067 0 .115-.031.149-.1L6.02 3.6l.01.211c.003.075.036.105.117.105.082 0 .14-.054.178-.176l.084-.27.026.282Zm-.886.58c-.147.01-.954.064-1.076.12-.002.002-.004.001-.005.002a.595.595 0 0 0 .072.021c.072.017.175.034.296.048.237.029.52.046.744.047.224-.001.506-.018.743-.047.122-.014.225-.031.297-.048a.54.54 0 0 0 .083-.024l.015-.007c0-.01.004-.021.007-.034-.026.04-.057.062-.099.043-.123-.057-.933-.112-1.077-.121Zm.809-.406a.254.254 0 0 1-.172.098c.357.05.61.12.618.123 0 0-.011.066-.03.138.017-.038.038-.082.065-.13l.006-.008.065-.062c-.092.016-.158.015-.193-.013a.442.442 0 0 1-.193.005c-.079-.013-.133-.065-.166-.151Zm-1.603 0c-.033.086-.088.138-.167.151a.44.44 0 0 1-.192-.005c-.028.023-.075.027-.139.02l.054.051c.06-.016.294-.076.607-.12a.254.254 0 0 1-.163-.097Zm1.196.011a.248.248 0 0 1-.095.051c.058.004.114.01.17.016a.18.18 0 0 1-.075-.067Zm-.79 0A.179.179 0 0 1 5.088 4c.053-.006.107-.01.163-.014a.25.25 0 0 1-.092-.05Zm.395-.056a.254.254 0 0 1-.11.097l.081-.002h.045l.095.002a.254.254 0 0 1-.111-.097Z"
        />
        <Path
          fill="#005BBF"
          fillRule="evenodd"
          d="M5.556 2.674a.168.168 0 1 0 0-.336.168.168 0 0 0 0 .336Z"
          clipRule="evenodd"
        />
        <Path
          fill="#C88A02"
          d="M4.022 3.795a.213.213 0 0 1 .062-.048c.068-.036.14-.032.163.01.021.04-.016.103-.084.139-.069.036-.142.032-.163-.009l-.001-.005a.054.054 0 0 1-.025.018c-.044.013-.098-.035-.12-.109-.023-.074-.006-.145.038-.159.045-.013.1.036.122.11a.219.219 0 0 1 .008.053Zm3.158-.18c.044.014.062.085.04.159-.023.074-.077.122-.122.11a.055.055 0 0 1-.025-.02v.006c-.022.041-.095.044-.163.008s-.106-.099-.084-.14c.022-.04.095-.044.163-.007.025.013.045.03.06.049.001-.018.004-.036.01-.055.023-.074.077-.123.121-.11Zm-2.517-.214c.045-.009.094.046.11.122a.207.207 0 0 1-.002.076.222.222 0 0 1 .057-.007c.077 0 .14.038.14.084 0 .046-.063.084-.14.084-.077 0-.14-.038-.14-.084l.001-.004h-.003l.002.004c0 .046-.062.084-.14.084-.077 0-.14-.038-.14-.084 0-.046.063-.084.14-.084.028 0 .054.006.076.015a.226.226 0 0 1-.017-.053c-.015-.076.01-.145.056-.153Zm1.727-.02c.047-.003.087.058.091.135a.206.206 0 0 1-.012.076.221.221 0 0 1 .058.001c.077.01.133.057.127.103-.007.045-.074.074-.15.063-.077-.01-.134-.057-.127-.103v-.003l-.001-.001v.004c-.006.046-.073.075-.15.064-.076-.01-.133-.057-.127-.103.007-.045.074-.074.15-.063a.21.21 0 0 1 .074.025.223.223 0 0 1-.01-.054c-.004-.078.03-.142.077-.145Zm-.887-.036c.045-.009.094.045.109.121a.208.208 0 0 1-.001.078.22.22 0 0 1 .057-.008c.077 0 .14.038.14.084 0 .047-.063.084-.14.084-.077 0-.14-.037-.14-.084v-.005h-.002l.002.005c0 .047-.063.084-.14.084-.077 0-.14-.037-.14-.084 0-.046.063-.084.14-.084.028 0 .054.007.075.015a.224.224 0 0 1-.016-.053c-.015-.076.01-.144.056-.153ZM5.61 2.112h.077v.117H5.61v.233h.077v.116h-.271v-.116h.077V2.23h-.077v-.117h.077v-.074h.117v.074Z"
        />
        <Path fill="#C88A02" d="M5.472 2.672h.224V3.4h-.224z" />
        <Path
          fill="#fff"
          d="M4.57 2.794v.056c-.497-.009-.782.064-.854.208-.075.15-.061.331.044.547l-.05.024c-.113-.23-.128-.43-.044-.596.085-.171.387-.248.904-.24Z"
        />
        <Path
          fill="#fff"
          d="m4.666 3.29-.028.049c-.108-.065-.163-.175-.163-.327 0-.218.113-.346.362-.434.158-.056.375-.033.65.067l-.019.053C5.204 2.602 5 2.58 4.855 2.63c-.228.08-.324.19-.324.381 0 .133.045.225.135.278Z"
        />
        <Path
          fill="#C88A02"
          d="m3.83 3.519-.106.037c-.11-.312-.078-.524.11-.616.165-.08.405-.113.722-.1l-.004.112c-.3-.013-.524.018-.67.089-.123.06-.145.212-.052.478Z"
        />
        <Path
          fill="#C88A02"
          d="M5.065 2.72c-.256 0-.362.062-.422.246-.038.117 0 .217.12.31l-.069.09c-.156-.122-.21-.27-.157-.435.076-.234.227-.324.528-.324.197 0 .35.052.458.158l.016.016v.54h-.112V2.83c-.083-.073-.203-.11-.362-.11Z"
        />
        <Path
          fill="#fff"
          d="M6.525 2.85v.056c.497-.009.782.064.854.208.075.15.061.33-.044.546l.05.025c.112-.23.128-.43.044-.596-.086-.172-.387-.248-.904-.24Z"
        />
        <Path
          fill="#fff"
          d="m6.35 3.302.028.048c.108-.064.162-.174.162-.326 0-.219-.112-.347-.36-.434-.16-.056-.376-.033-.652.067l.02.052c.264-.095.468-.117.612-.066.229.08.324.189.324.38 0 .134-.045.225-.135.28Z"
        />
        <Path
          fill="#C88A02"
          d="m7.3 3.575.105.037c.11-.312.079-.524-.109-.616-.165-.08-.405-.113-.723-.1l.005.111c.3-.012.524.019.67.09.122.06.145.212.052.478Z"
        />
        <Path
          fill="#C88A02"
          d="M6.059 2.728c.256 0 .36.062.421.246.038.118.001.218-.12.311l.07.089c.155-.121.21-.27.156-.434-.076-.235-.226-.324-.527-.324-.198 0-.351.052-.458.157l-.017.017v.54h.112v-.492c.084-.073.204-.11.363-.11Z"
        />
        <Path
          fill="#E1E5E8"
          fillRule="evenodd"
          d="M3.736 4.632h3.64v3.27S7.106 9 5.556 9s-1.82-1.126-1.82-1.126V4.632Z"
          clipRule="evenodd"
          opacity={0.3}
        />
        <Mask
          id="e"
          width={5}
          height={5}
          x={3}
          y={4}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M3.736 4.632h3.64v3.27S7.106 9 5.556 9s-1.82-1.126-1.82-1.126V4.632Z"
            clipRule="evenodd"
          />
        </Mask>
        <G mask="url(#e)">
          <Path fill="#FFC034" d="M3.736 6.648h1.848v2.184H3.736z" />
          <Path
            fill="#AD1619"
            d="M3.96 6.76h.224v2.072H3.96zM4.744 6.76h.224v2.072h-.224zM4.352 6.76h.224v2.072h-.224zM5.136 6.76h.224v2.072h-.224zM3.736 4.576h1.848v2.128H3.736z"
          />
          <Path fill="#AD1619" d="M5.528 6.592h1.848V8.72H5.528z" />
          <Path fill="#F1F9FF" d="M5.528 4.632h1.96v2.072h-1.96z" />
          <Path
            fill="#C88A02"
            d="M4.688 5.265H4.8v-.233h.168v.233h.168v.29h-.168v.522h.168v.291H4.128v-.29h.168v-.523h-.168v-.29h.112v-.233h.168v.233h.112V4.8h.168v.465Z"
          />
          <Path
            fill="#C37C9C"
            d="M6.313 4.902c.133-.053.289.003.42.192.076.107.076.225.002.319a.401.401 0 0 1-.152.108c.048.069.077.106.126.161.023.026.042.052.06.076.018-.01.04-.02.068-.028l.014-.005a.869.869 0 0 0 .04-.011c.046-.016.045-.01.045-.145v-.021c0-.034-.002-.063-.004-.128v-.007c-.01-.242-.001-.335.073-.402l.074.083c-.036.033-.044.117-.036.314v.007c.003.067.004.097.004.133v.021c0 .178-.013.215-.12.251a.923.923 0 0 1-.046.014l-.012.003a.221.221 0 0 0-.037.013c.01.018.022.033.028.048.03.072.02.138-.035.178l.001.006.002.01a.489.489 0 0 1-.007.16.406.406 0 0 0-.003.111c-.003-.01-.017-.02-.035-.02l-.005-.004-.002.003h.007l.003.003-.006.001-.005-.004-.01.01a.061.061 0 0 1 .015-.006l.075.068c-.048.052-.116.06-.142-.013a.398.398 0 0 1-.003-.161.658.658 0 0 0 .01-.122l-.004-.013a.47.47 0 0 1-.006-.089l-.045.1c-.05-.023-.075-.045-.082-.081a.08.08 0 0 1 .003-.036.207.207 0 0 1 .006-.019c.006-.016.004-.025-.02-.06l-.02-.027c-.002 0-.005 0-.007-.002a.834.834 0 0 0-.066-.017l.021.053.038.085a.278.278 0 0 1 .025.09c.006.115-.087.143-.203.109a.807.807 0 0 0-.141-.034c.038-.002.059-.043.057-.06l-.167.026c-.01-.071.02-.132.105-.134.032-.001.073.007.151.029l-.02-.044a.97.97 0 0 1-.041-.11c-.03-.096.02-.172.112-.182h.015l-.064-.11c-.012.003-.023.007-.034.008l-.007-.044a1.18 1.18 0 0 1-.14.138c-.11.088-.214.117-.292.03l.125-.113c-.005-.004-.011-.006-.007-.007a.238.238 0 0 0 .07-.042.955.955 0 0 0 .1-.095.643.643 0 0 1-.138-.128.456.456 0 0 0-.092-.088c-.014-.01-.054-.033-.06-.036-.07-.047-.066-.091-.024-.197l.157.063-.006.013.029.018c.04.028.082.066.125.12a.428.428 0 0 0 .12.107l-.002-.016a.755.755 0 0 0 .14-.037.323.323 0 0 0 .071-.035c-.037-.053-.068-.079-.089-.086-.002-.001 0 0 .004-.002l.015-.01-.166-.225a.21.21 0 0 1 .047-.026Zm.393 1.062c0 .015-.001.03-.006.045l.01.004v-.006l-.002-.04-.002-.003Z"
          />
          <Path
            fill="#C88A02"
            d="m6.49 4.898.114-.123.24.225-.114.123-.24-.225Z"
          />
          <Path
            fill="#FFC034"
            d="m7.18 8.07-.003.01c-.07.295-.312.444-.697.444-.385 0-.627-.153-.698-.454l-.002-.01V6.844h1.4V8.07Zm-1.232-.03c.054.212.223.316.532.316.31 0 .479-.101.532-.306V7.012H5.948V8.04Z"
          />
          <Path
            fill="#FFC034"
            d="m6.538 7.444.406-.442.082.076-.416.453h.466v.167h-.474l.424.462-.082.077-.406-.443v.592h-.117v-.65l-.46.5-.082-.076.424-.462h-.385v-.167h.377l-.416-.453.082-.076.46.5v-.555h.117v.497Z"
          />
          <Path
            fill="#F1F9FF"
            fillRule="evenodd"
            d="M6.741 8.722s-1.186.093-1.186-.672c0 0-.011.672-1.25.672v.603h2.436v-.603Z"
            clipRule="evenodd"
          />
          <Path
            fill="#005BBF"
            fillRule="evenodd"
            stroke="#AD1619"
            strokeWidth={0.583}
            d="M5.556 7.096c.232 0 .42-.2.42-.448 0-.247-.188-.448-.42-.448-.232 0-.42.2-.42.448 0 .247.188.448.42.448Z"
            clipRule="evenodd"
          />
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
